import { cloneElement } from 'react';
import { PropTypes } from 'prop-types';
import styles from './IMSDataTable.module.scss';
import classNames from 'classnames';

const IMSDataTable = props => {
	return (
		<>
			<div className={styles.container_main}>
				{props.filterControls ? (
					<IMSDataTableControls {...props} />
				) : null}
				<IMSDataTablePaginationControls {...props} />
				<table className={styles.table}>
					<thead className={styles.headerRow}>
						<tr>
							{props.headers.map(header => {
								return (
									<th
										key={header.dataKey}
										className={styles.cell}
									>
										{header.displayHeader}
									</th>
								);
							})}
						</tr>
					</thead>
					<IMSDataTableBody {...props} />
				</table>
				{props.isLoading ? <div>Loading...</div> : null}
				{props.error != null ? <p>{props.error}</p> : null}
				{(props.error == null && props.data.length < 1) ||
				(props.error == null &&
					props.paginated &&
					props.data[0].length === 0) ? (
					<p>No results, Try adjusting your search parameters</p>
				) : null}
			</div>
		</>
	);
};

//internal components-----------------------------------------------------------------------

const IMSDataTablePaginationControls = props => {
	const arrowLeft = '<';
	const arrowRight = '>';

	const renderConditionally = () => {
		return props.paginated === true ? (
			<div className={styles.paginationControlsContainer}>
				<div
					className={classNames(
						styles.paginationControl,
						styles.clickable
					)}
					onClick={props.pageDown}
				>
					{arrowLeft}
				</div>
				<div className={styles.paginationControl}>
					{props.currentPage} - {props.totalPages}
				</div>
				<div
					className={classNames(
						styles.paginationControl,
						styles.clickable
					)}
					onClick={props.pageUp}
				>
					{arrowRight}
				</div>
			</div>
		) : null;
	};

	return renderConditionally();
};
//-------------------------------------------------------------------------------------------------------------------------------------------------IMSDataTableBody Definition
const IMSDataTableBody = props => {
	const renderTableData = () => {
		let rows = [];
		//standard implementation without customTd props
		if (props.customTdProps === null || props.customTdProps === undefined) {
			props.data.forEach((element, index) => {
				rows.push(
					<tr className={alternatesClass(index)} key={index}>
						{props.headers.map((row, headerIndex) => {
							return (
								<td
									key={`${index}-${headerIndex}-td`}
									className={styles.cell}
								>
									{!row.value
										? element[row.dataKey]
										: row.value}
								</td>
							);
						})}
					</tr>
				);
			});
		}
		//handle custom td
		else {
			props.data.forEach((element, index) => {
				rows.push(
					<tr className={alternatesClass(index)} key={index}>
						{props.headers.map((row, headerIndex) => {
							if (
								headerIndex !== props.customTdProps.columnIndex
							) {
								return (
									<td
										key={`${index}-${headerIndex}-td`}
										className={styles.cell}
									>
										{!row.value
											? element[row.dataKey]
											: row.value}
									</td>
								);
							} else {
								return cloneElement(
									props.customTdProps.customTDElementAtIndex,
									{
										element: element,
										key: `${index}-${headerIndex}-td`,
									}
								);
							}
						})}
					</tr>
				);
			});
		}

		return rows;
	};

	const alternatesClass = int => {
		if (int % 2 > 0) {
			return styles.rowBackground1;
		} else {
			return styles.rowBackground2;
		}
	};

	return <tbody>{renderTableData()}</tbody>;
};
//-------------------------------------------------------------------------------------------------------------------------------------------------IMSDataTableControls Definition
const IMSDataTableControls = ({ filterControls, onSearch, activeFilter }) => {
	const renderInput = controlProps => {
		switch (controlProps.type) {
			case 'text':
				return (
					<input
						type='text'
						placeholder={controlProps.label}
						{...controlProps}
					/>
				);
			case 'select':
				return (
					<select {...controlProps}>
						{controlProps.options.map((option, index) => {
							return (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							);
						})}
					</select>
				);
			default:
				break;
		}
	};

	const renderControls = () => {
		return filterControls.map((control, index) => {
			return (
				<div className={styles.filterControlContainer} key={index}>
					<p className={styles.controlLabel}>{control.label}</p>
					{renderInput(control)}
				</div>
			);
		});
	};

	return (
		<div className={styles.controls_container}>
			<div className={styles.findBy}>
				<strong>Find by: {activeFilter}</strong>
			</div>
			{renderControls()}
			<div className={styles.filterControlContainer}>
				<div className={styles.buttonContainer}>
					<button className={styles.button} onClick={onSearch}>
						Search
					</button>
				</div>
			</div>
		</div>
	);
};

//PropType Definitions----------------------------------------
IMSDataTable.propTypes = {
	data: PropTypes.array.isRequired,
	isLoading: PropTypes.bool,
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			dataKey: PropTypes.string.isRequired,
			displayHeader: PropTypes.string.isRequired,
		}).isRequired
	),
	filterControls: PropTypes.arrayOf(
		PropTypes.shape({
			type: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			onChange: PropTypes.func,
			onFocus: PropTypes.func,
		})
	),
	onSearch: PropTypes.func,
	activeFilter: PropTypes.string,
	paginated: PropTypes.bool,
	pageUp: PropTypes.func,
	pageDown: PropTypes.func,
	currentPage: PropTypes.number,
	customTdProps: PropTypes.shape({
		columnIndex: PropTypes.number.isRequired,
		customTDElementAtIndex: PropTypes.element.isRequired,
	}),
};

IMSDataTable.defaultProps = {
	isLoading: false,
	paginated: false,
};

export default IMSDataTable;
